import { css } from 'linaria';

export const root = css`
    margin: 0;
    padding: 0;
    position: relative;
    width: 100%;
    height: 100%;
    flex-shrink: 0;

    scroll-snap-align: center;
    scroll-snap-stop: always;
`;
